//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import select from '~/mixins/components/select';

export default {
  name: 'select-custom',
  mixins: [select],
  props: {
    alwaysLabel: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => ([]),
    },
  },
};
